import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[itemContent]',
})
export class ContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
